<template>
  <div>
    <div class="realbody ">
      <div class="container" style="margin-top: 100px;">
        <div class="row">
          <span class="d-none">{{calculateAverage}}</span>
          <div class=" col-md-12 top-fix-score text-center">
            <div class=" row text-center statuspanel" style="height: 80px;">
              <div class="col-md-4 totalcol">
                <p class="cocogothic spacing3-2 noiseblack statustitle">{{$t('sk_total_lb')}}</p>
                <h3 class="mplus2p-r noiseblack statustitle text-center" id="total">{{model.total}}</h3>
              </div>
              <div class="col-md-4 totalcol">
                <p class="cocogothic spacing3-2 noiseblack statustitle">{{$t('sk_technical_lb')}}</p>
                <div class="chartboxes">
                  <h3 class="mplus2p-r noiseblack statustitle" id="technical">{{model.technical}}</h3>
                </div>
              </div>
              <div class="col-md-4 totalcol">
                <p class="cocogothic spacing3-2 noiseblack statustitle">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</p>
                <div class="chartboxes">
                  <h3 class="mplus2p-r noiseblack statustitle" id="management">{{model.management}}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mainbody text-center" style="top: 100px; margin-bottom: 150px">
            <p class="r_panel_title mplus2p-r spacing4 black" style="margin-top: 30px;">{{$t('sk_page_title')}}</p>
            <p class="mplus2p-r spacing1-2 black" style="font-size: 0.75rem;">{{$t('sk_page_sub_title')}}</p>
            <div class="col-md-12 skill-mobile">
              <div class="row slide_options">
                <div class="col-md-6 slide_item spressed" id="s1" @click="pressed_slide(1)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_technical_lb')}}</span>
                </div>
                <div class="col-md-6 slide_item" id="s2" @click="pressed_slide(2)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</span>
                </div>
              </div>

              <div id="technicalTab" v-show="panelid === 1" class="row qaboxes text-left">
                <div class="col-md-12">
                  <p class="r_panel_title mplus2p-r spacing4 black" style="margin-top: 30px;">{{$t('sk_sentence1')}}</p>
                  <p class="mplus2p-r spacing1-2 black" style="font-size: 0.90rem;">
                    <span style="color: red;">{{$t('sk_asterisk')}}</span>{{$t('sk_sentence2')}}
                  </p>
                  <p class="mplus2p-r spacing1-2 black" style="font-size: 0.90rem;">
                    <span style="color: red;">{{$t('sk_asterisk')}}</span>{{$t('sk_sentence3')}}
                  </p>
                </div>
                <div class="col-md-12"><hr class="cline"></div>
                <div class="col-md-12">
                  <technical-skill></technical-skill>
                </div>
              </div>
              <div id="managementTab" v-show="panelid === 2" class="row qaboxes text-left">
                <div class="col-md-12">
                  <p class="r_panel_title mplus2p-r spacing4 black" style="margin-top: 30px;">{{$t('sk_sentence1')}}</p>
                  <p class="mplus2p-r spacing1-2 black" style="font-size: 0.90rem;">
                    <span style="color: red;">{{$t('sk_asterisk')}}</span>{{$t('sk_sentence2')}}
                  </p>
                  <p class="mplus2p-r spacing1-2 black" style="font-size: 0.90rem;">
                    <span style="color: red;">{{$t('sk_asterisk')}}</span>{{$t('sk_sentence3')}}
                  </p>
                </div>
                <div class="col-md-12"><hr class="cline"></div>
                <div class="col-md-12">
                  <management-skill></management-skill>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer dark_bg fixed-bottom-footer">
      <div class="container ">
        <div class="row sections" style="padding-top: 10px; padding-bottom: 10px">
          <img src="../../assets/imgs/logo-white.png" style="margin: auto;">
        </div>
        <div class="row sections text-center" style="padding-top: 0px; padding-bottom: 10px;">
          <p class="white mplus1c spacing1-2" style="margin: auto; font-size: 12px;">
            {{$t('f_copyright')}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import {EventBus} from "../../main.js";
  import technicalSkill from "./technicalSkill.vue";
  import managementSkill from "./managementSkill.vue";

  export default {
    data() {
      return {
        isActive: true,
        lan: "",
        techTotal: "",
        mangTotal: "",
        routeLeave: 0,
        item: "",
        techLoaded: false,
        mangLoaded: false,

        model: {},

        skillLevelId: [],
        custom_skill: [],

        techItemId: [],
        techCustom_skill: [],
        techSkillLevelId: [],

        itemId: [],
        skill: "",
        type: "",
        level: "",

        panelid: 1,
        result: '',

        scrollY: 0
      };
    },
    components: {
      technicalSkill,
      managementSkill
    },
    created() {
      window.addEventListener('onbeforeunload', this.handler)
      this.model.total = 0;
      this.model.technical = 0;
      this.model.management = 0;

      if ("lan" in localStorage) {
        this.lan = localStorage.getItem("lan");
      }
      this.pressed_slide(this.panelid);
      this.getFristLogin();
      $('#appFooter').remove();
    },
    mounted() {
      EventBus.$on("language", data => {
        this.lan = data;
      });
      this.$on("managementTotal", data => {
        this.$forceUpdate();
        this.model.management = data;
        this.mangTotal = data;
      });
      this.$on("technicalTotal", data => {
        this.$forceUpdate();
        this.model.technical = data;
        this.techTotal = data;
      });
      this.$on("managementId", data => {
        this.$forceUpdate();
        this.itemId = data.itemId;
        this.skillLevelId = data.level_id;
        this.custom_skill = data.custom_skill;
        this.mangLoaded = data.loaded;
        this.doUpdateSkill()
      });
      this.$on("technicalId", data => {
        this.$forceUpdate();
        this.techItemId = data.itemId;
        this.techSkillLevelId = data.level_id;
        this.techCustom_skill = data.custom_skill;
        this.techLoaded = data.loaded;
        this.doUpdateSkill();
      });
      window.addEventListener('scroll', this.handleScroll);
    },
    computed: {
      onResize(event) {
        this.doCenter();
      },
      checkAddButton() {
        return true;
      },
      calculateAverage() {
        this.model.total =
        this.techTotal + this.mangTotal ? this.techTotal + this.mangTotal : 0;
      }
    },
    methods: {
      handler: function handler(event) {
          console.log(event);
      },
      getFristLogin() {
      axios
        .post("first/login?token=" + localStorage.getItem("token"))
        .then(res => {
          if (res.data.result) {
          }
        })
        .catch(error => {
        });
      },
      pressed_slide(id) {
        this.panelid = id;
        $(".slide_item").removeClass("spressed");
        $("#s" + id).addClass("spressed");
        if (this.panelid === 1) {
          $(".pview").css("display", "inline-flex");
          $(".eview").css("display", "none");
        }
        if (this.panelid === 2) {
          $(".eview").css("display", "inline-flex");
          $(".pview").css("display", "none");
        }
      },

      doUpdateSkill() {
        if (!this.techLoaded && !this.mangLoaded) {
          return
        }
        this.routeLeave = 1;
        var token = localStorage.getItem("token");
        const thisVue = this;
        let arr = {};
        for (let item in this.custom_skill) {
          if (this.custom_skill[item] != undefined) {
            arr[item] = this.custom_skill[item];
          }
        }
        for (let item in this.techCustom_skill) {
          if (this.techCustom_skill[item] != undefined) {
            arr[item] = this.techCustom_skill[item];
          }
        }
        const dataToSend = {
          item_id: this.itemId.concat(this.techItemId),
          level_id:  this.skillLevelId.concat(this.techSkillLevelId),
          custom_skill: arr
        };

        if (dataToSend.item_id == "" && dataToSend.level_id == "") {
          this.$toaster.error(thisVue.$t("err_skill"));
          return;
        }
        return axios
          .post("/skill-update?token=" + token, dataToSend)
          .then(res => {
            this.result = res
          })
          .catch(err => {
          });
      },
      handleScroll() {
        this.scrollY = window.scrollY;
      }
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.cline{
    margin-top: 1rem;
    border: 0;
    border-top: 2px solid rgba(0,0,0,.1);
}
  .top-fix-score {
    position: fixed;
    top: 60px;
    right: 0;
    left: 0;
    z-index: 800;
  }

  .fixed-bottom-button {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 800;
  }

  .skillTag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #3d7dd8 !important;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    min-height: 22px !important;
  }

  .resultshow ul li {
    -webkit-animation: animationtags 1s ease-out; /* Safari 4.0 - 8.0 */
    animation: animationtags 1s ease-out;
    animation-iteration-count: 1;
  }

  /* Standard syntax */
  @keyframes animationtags {
    0% {
      width: 100%;
      transform: rotate(-6deg);
    }
    100% {
      width: 100%;
      transform: rotate(0deg);
    }
  }

  .chooseskillssection input[type="checkbox"] {
    -webkit-appearance: none;
  }

  .level_btns input[type="radio"] {
    display: none;
  }

  /* Standard syntax */
  @keyframes animationtags {
    0% {
      width: 100%;
      transform: rotate(-6deg);
    }
    100% {
      width: 100%;
      transform: rotate(0deg);
    }
  }

  .chooseskillssection input[type="checkbox"] {
    -webkit-appearance: none;
  }

  .level_btns input[type="radio"] {
    display: none;
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
  }

  .facheck:before {
    content: "\f00c";
  }


  header .logo {
    text-align: center;
  }

  .chooseskillssection {
    float: left;
    width: 100%;
    margin: 10px 0;
  }

  .chooseskillssection li {
    display: inline-block;
  }

  .chooseskillssection li label {
    color: #404040;
    background: #d0cbcb;
    padding: 4px 10px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    margin: 2px;
    cursor: pointer;
  }

  .chooseskillssection li label.clicked {
    /* background: rgba(50, 209, 108, 0.65); */
    color: #fff;
    background: #3d7dd8;
  }

  .multiselect__tags-wrap .multiselect__tag {
    background: #3d7dd8 !important;
  }

  .selectexpertlevel {
    float: left;
    width: 100%;
    margin-top: 20px;
  }

  .selectexpertlevel > div.level_btns {
    display: inline-grid;
    width: 33%;
    text-align: center;
  }

  .selectexpertlevel > div label {
    padding: 20px;
    display: block;
    height: 200px;
    background: #fff;
    box-shadow: 2px 2px 2px 2px #ccc;
    margin: 10px;
    min-height: 100px;
    cursor: pointer;
  }

  .selectexpertlevel > div label:hover {
    background: #efeeee;
  }

  .selectexpertlevel > div label span {
    width: 60%;
    float: left;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d2cfcf;
    margin-left: 20%;
    margin-right: 20%;
  }

  .resultshow {
    float: left;
    width: 100%;
    background: #fff;
    min-height: 100px;
  }

  .resultshow > div {
    float: left;
    width: 100%;
    min-height: 100px;
  }

  .resultshow ul {
    padding-left: 10px;
    margin-top: 11px;
    list-style: none;
    text-align: left;
  }

  .resultshow ul li {
    display: list-item;
    padding-left: 0;
    float: left;
    width: 100%;
  }

  .resultshow ul li span {
    /* color: #404040;
    background: #d0cbcb; */
    color: #fff;
    background: #3d7dd8;
    padding: 4px 10px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    margin: 2px;
    float: left;
  }

  .filterSpinner {
    color: #3d7dd8;
  }

  button.save_btn {
    background: #088e38;
    color: #fff;
    border: none;
    padding: 10px 40px;
    font-size: 20px;
    margin-bottom: 20px;
    margin-top: 10px;
    float: left;
    cursor: pointer;
  }

  button.save_btn:hover {
    opacity: 0.9;
  }

  .finalResult {
    float: left;
    width: 100%;
  }

  .finalResult ul li {
    margin-bottom: 0px;
    width: 100%;
    display: inline-block;
    border-bottom: 1px solid #ccc;
  }

  .finalResult ul li p {
    margin-left: 10px;
  }

  .finalResult ul li h5 {
    margin-bottom: 7px;
    float: left;
    width: 100%;
  }

  .skill_questions {
    display: block;
    float: left;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }

  .mainbody:after {
    position: absolute;
    content: url("../../assets/imgs/zoomtool.png");
    top: -1px;
    right: 60px;
    margin-top: 25px;
  }

  .regselectboxs {
    float: left;
    margin-left: 16px;
  }

  .reglabels {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 20px 0;
  }

  .regradioboxs {
    text-align: center;
    min-width: 145px;
    height: 50px;
    float: left;
    background-color: #ffffff;
    border: 1px solid #b4bec8;
    color: #b4bec8;
    margin-left: 16px;
    margin-top: 5px;
    padding-top: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .manradio:hover,
  .mchosen {
    border: 1px solid #3d7dd8;
    color: #3d7dd8;
  }

  .womenradio:hover,
  .wchosen {
    border: 1px solid #f878c8;
    color: #f878c8;
  }


  .regradiotxt {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .regnext_btn {
    width: 100%;
    height: 56px;
    font-weight: bold;
    font-size: 1rem;
  }

  .skipbtn {
    margin-top: 25px;
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
  }

  .selectdiv select {
    height: 50px !important;
  }

  .sexerror {
    margin-top: 60px;
    margin-bottom: 20px;
    margin-left: 16px;
  }

  @media screen and (max-width: 1200px) {
    .mainbody:after {
      right: 20px;
    }

    .regselectboxs {
      float: left;
      margin-left: 5px;
    }

    .regradioboxs {
      margin-left: 5px;
    }

    .sexerror {
      margin-left: 5px;
    }
  }


  .statuspanel {
    background-color: #f8f8fa;
  }

  .statustitle {
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 0.1rem;
  }

  .radiolabel {
    font-size: 0.875rem;
    font-weight: 500;
  }

  input[type="radio"] {
    margin: 0 20px;
    width: 16px;
    height: 16px;
    background: #f0f2f4;
    box-shadow: inset 0 0 0 0em white, 0 0 0 0.05em;
    border-radius: 50%;
    transition: 0.2s;
    cursor: pointer;
    color: #dcdee0;
  }

  input[type="radio"]:hover,
  input[type="radio"]:checked {
    background: #3d7dd8;
    box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.3em;
  }

  input[type="radio"]:checked {
    background: #3d7dd8;
    box-shadow: inset 0 0 0 0.15em white, 0 0 0 0.1em #3d7dd8;
  }

  input[type="radio"]:focus {
    outline: 0;
  }

  .paddings {
    padding: 0px 150px;
  }

  .qtitle {
    font-size: 0.875rem;
    margin-left: 19px;
    font-weight: 500;
  }

  .qaboxes {
    margin-top: 30px;
  }

  .chartboxes {
    display: block;
    margin: auto;
    margin-bottom: 30px;
    max-width: 200px;
    height: 100px;
  }

  .statusnum {
    position: absolute;
    right: 46%;
    top: 55%;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .two-digit statusnum {
    right: 45%;
  }

  .three-digit {
    right: 43%;
  }

  .totalcol::after {
    content: "";
    border-left: 2px solid #e4e4e6;
    position: absolute;
    height: 35%;
    right: 0;
    top: 8%;
  }


  @media screen and (max-width: 992px) {

  .statustitle {
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 0.1rem;
}
    .totalcol{
      width: 33.333333%;
      padding: 0px
    }
    .top-fix-score {
    position: fixed;
    width: auto;
    height: auto;
    display: block;
    top: 52px;
    right: 0;
    left: 0;
    z-index: 800;
  }
    .top-fix-score {
    position: fixed;
    width: 100%;
    height: 100%;
    display: block;
    top: 60px;
    right: 0;
    left: 0;
    z-index: 800;
  }

  .fixed-bottom-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 800;
  }
    .mainbody:after {
      right: -60px;
    }

    .totalcol::after {
      content: "";
      border-left: 2px solid #e4e4e6;
      position: absolute;
      height: 38%;
      right: 0;
      top: 8%;
    }
  }


  @media screen and (max-width: 768px) {
    .statustitle {
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 0.1rem;
}
    .totalcol{
      width: 33.333333%;
      padding: 0px
    }
    .top-fix-score {
    position: fixed;
    width: auto;
    height: auto;
    display: block;
    top: 52px;
    right: 0;
    left: 0;
    z-index: 800;
  }

  .fixed-bottom-footer {
    position: sticky;
    bottom: 0;
    right: 0;
    width: auto;
    height: auto;
    left: 0;
    z-index: 800;
  }
    .mainbody:after {
      right: -60px;
    }

    .totalcol::after {
      content: "";
      border-left: 2px solid #e4e4e6;
      position: absolute;
      height: 36%;
      right: 0;
      top: 8%;
    }
  }

  @media screen and (max-width: 678px) {
    .mainbody:after {
      right: 0px;
      margin-top: -60px;
    }

    .mainbody {
      margin-top: 40px;
    }
  }

  @media screen and (max-width: 369px) {
    .regradioboxs {
      margin-top: 10px;
      width: 100%;
      margin-left: 0px;
    }
  }

  .pman {
    width: 120px;
    margin-top: 70px;
  }

  .slide_options {
    background-color: #f8fafa;
    border-radius: 30px;
    margin: 10px 0px;
    margin-top: 44px;
    padding: 5px 0px;
  }

  .slide_item {
    text-align: center;
    padding: 18px;
    cursor: pointer;
  }

  .spressed {
    text-align: center;
    padding: 18px;
    border-radius: 30px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
  }

  .slide_txt {
    font-size: 1rem;
    font-weight: bold;
    color: #b4bec8;
  }

  .spressed .slide_txt {
    font-size: 1rem;
    font-weight: bold;
    color: #3d7dd8;
  }

  .pview {
    margin-top: 38.5px;
    margin-bottom: 80px;
  }

  .avatar {
    width: 80%;
  }

  .pgraytxt {
    opacity: 0.64;
    font-size: 1rem;
    font-weight: 500;
  }

  .cs_summary {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    margin-top: 21px;
  }

  .pvlabel {
    margin-left: 20px;
  }

  .pv_btnpanel {
    padding: 0px 10%;
  }

  .updatebtn {
    width: 100%;
    height: 56px;
  }

  .pv_showchart {
    background-color: #f8f8fa;
    margin-top: 16px;
  }

  .eview {
    padding: 30px 15px;
  }


  .statusnum {
    position: absolute;
    /*right: 46%;
      top: 55%;*/
    font-weight: bold;
    font-size: 1.5rem;
  }

  .caltxt {
    margin-top: 45px;
  }

  .calpanel {
    text-align: right;
  }

  @media screen and (max-width: 768px) {
    .pman {
      margin-top: 0px;
    }

    .avatar {
      width: 50%;
    }

    .page_title {
      margin-top: 40px;
    }

    .pvlabel {
      margin-left: 0px;
    }

    .calpanel {
      text-align: center;
    }
  }
</style>
